/* eslint-disable object-curly-newline */
/* eslint-disable */
import { IContactItem, IAudienceListContactsState, IAudienceListDetailsAction } from '../interface';
import {
  LIST_CONTACTS,
  LIST_CONTACTS_SEARCH,
  LIST_CONTACTS_DELETE_CONTACTS,
  LIST_CONTACTS_EDIT_LISTNAME,
  LIST_CONTACTS_ADD_NEW_CONTACT,
  LIST_CONTACTS_UPDATE_CONTACT,
  LIST_CONTACTS_ADD_TO_LIST,
} from '../../../constants/types/audienceTypesNew';

const audienceListDetailsInitialState: IAudienceListContactsState = {
  listId: 0,
  listName: '',
  message: '',
  success: false,
  loading: false,
  listContacts: Array<IContactItem>(),
  searchTerm: '',
  totalContacts: 0,
  page: 0,
  searchedlistContacts: Array<IContactItem>(),
  searchedLoading: false,
  searchedPage: 0,
  totalSearchedContacts: 0,
  selectedContacts: Array<IContactItem>(),
  allContactsSelected: false,
  reloadListContacts: false,
  openListLoading: false,
  deleteContact: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  editListName: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  addNewContact: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  editContact: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
};

export const audienceListDetailsReducerV2 = (state = audienceListDetailsInitialState, action: IAudienceListDetailsAction) => {
  const newState = { ...state };
  const { payload } = action;

  switch (action.type) {
    // case LIST_CONTACTS.LOAD:
    //   newState.loading = true;
    //   return newState;

    // case LIST_CONTACTS.SUCCESS:
    //   newState.loading = false;
    //   newState.page = state.page + 1;
    //   if (action.payload) {
    //     if (newState.listContacts.length > 0) {
    //       newState.listContacts = [...newState.listContacts, ...(payload.listContacts as IContactItem[])];
    //     } else {
    //       newState.listContacts = payload.listContacts as IContactItem[];
    //     }
    //     if (payload.totalContacts) {
    //       newState.totalContacts = payload.totalContacts as number;
    //     }
    //     if (payload.listName) {
    //       newState.listName = payload.listName as string;
    //     }
    //     newState.listId = payload.listId as number;
    //     newState.message = payload.message as string;
    //     newState.success = payload.success as boolean;
    //   }
    //   return newState;

    // case LIST_CONTACTS.FAIL:
    //   newState.loading = false;
    //   newState.message = payload.message as string;
    //   return newState;

    // case LIST_CONTACTS.ERROR:
    //   newState.loading = false;
    //   newState.success = false;
    //   newState.searchedLoading = false;
    //   newState.message = payload.message as string;
    //   return newState;

    // case LIST_CONTACTS.RELOAD:
    //   newState.reloadListContacts = payload.reloadFlag as boolean;
    //   return newState;

    // case LIST_CONTACTS.OPEN_LIST_LOADING:
    //   newState.openListLoading = payload.loading as boolean;
    //   return newState;

    // case LIST_CONTACTS.DATA_RESET:
    //   newState.listId = 0;
    //   newState.listName = '';
    //   newState.listContacts = [];
    //   newState.loading = false;
    //   newState.page = 0;
    //   newState.totalContacts = 0;
    //   return newState;

    // // SEARCH IN LIST CONTACTS

    // case LIST_CONTACTS_SEARCH.SET_SEARCH_TERM:
    //   console.log(payload.searchTerm);
    //   if (payload.searchTerm) {
    //     console.log(payload.searchTerm);
    //     if (payload.searchTerm !== newState.searchTerm) {
    //       console.log(payload.searchTerm);
    //       newState.searchTerm = payload.searchTerm as string;
    //       newState.searchedlistContacts = [];
    //       // newState.listContacts = [];
    //       newState.searchedPage = 0;
    //       newState.totalSearchedContacts = 0;
    //     }
    //   } else {
    //     newState.searchTerm = payload.searchTerm as string;
    //   }
    //   return newState;

    // case LIST_CONTACTS_SEARCH.LOAD:
    //   newState.searchedLoading = true;
    //   return newState;

    // case LIST_CONTACTS_SEARCH.SUCCESS:
    //   newState.searchedLoading = false;
    //   newState.searchedPage += 1;
    //   if (action.payload) {
    //     if (newState.searchedlistContacts.length > 0) {
    //       newState.searchedlistContacts = [...newState.searchedlistContacts, ...(payload.listContacts as IContactItem[])];
    //     } else {
    //       newState.searchedlistContacts = payload.listContacts as IContactItem[];
    //     }

    //     if (payload.totalContacts) {
    //       newState.totalSearchedContacts = payload.totalContacts as number;
    //       newState.listName = payload.listName as string;
    //     }

    //     newState.success = true;
    //   }
    //   return newState;

    // case LIST_CONTACTS_SEARCH.RESET:
    //   newState.searchedlistContacts = [];
    //   newState.searchedLoading = false;
    //   newState.searchedPage = 0;
    //   newState.page = 0;
    //   // newState.searchTerm = '';
    //   newState.totalSearchedContacts = 0;
    //   return newState;

    // case LIST_CONTACTS_SEARCH.REMOVE_SEARCH_TERM:
    //   newState.searchTerm = '';
    //   return newState;

    // case LIST_CONTACTS_DELETE_CONTACTS.LOAD:
    //   newState.deleteContact.loading = true;
    //   return newState;

    // case LIST_CONTACTS_DELETE_CONTACTS.SUCCESS: {
    //   // eslint-disable-next-line
    //   const { message, deleteAll, contactIds } = action.payload;
    //   let { excludedContactIds } = action.payload;
    //   excludedContactIds = excludedContactIds as number[];
    //   if (deleteAll && excludedContactIds.length > 0) {
    //     const ids = excludedContactIds;
    //     // eslint-disable-next-line
    //     if (newState.searchTerm !== '') {
    //       const filteredSearchedContacts = newState.searchedlistContacts.filter((contact) => ids.includes(contact.contactId));
    //       const contactsToRemove = newState.searchedlistContacts
    //         .filter((contact) => !ids.includes(contact.contactId))
    //         .map((removedContact) => removedContact.contactId);
    //       const filteredContacts = newState.listContacts.filter((contact) => !contactsToRemove.includes(contact.contactId));
    //       newState.listContacts = filteredContacts;
    //       newState.totalContacts -= newState.totalSearchedContacts - ids.length;
    //       newState.searchedlistContacts = filteredSearchedContacts;
    //       newState.totalSearchedContacts = filteredSearchedContacts.length;
    //     } else {
    //       const filteredContacts = newState.listContacts.filter((contact) => ids.includes(contact.contactId));
    //       newState.listContacts = filteredContacts;
    //       newState.totalContacts = filteredContacts.length;
    //     }
    //   } else if (deleteAll) {
    //     if (newState.searchTerm !== '') {
    //       newState.totalContacts -= newState.totalSearchedContacts;
    //       newState.searchedlistContacts = [];
    //       newState.totalSearchedContacts = 0;
    //     } else {
    //       newState.listContacts = [];
    //       newState.totalContacts = 0;
    //     }
    //   } else {
    //     const ids = contactIds as number[];
    //     if (newState.searchTerm !== '') {
    //       const filteredSearchedContacts = newState.searchedlistContacts.filter((contact) => !ids.includes(contact.contactId));
    //       const filteredContacts = newState.listContacts.filter((contact) => !ids.includes(contact.contactId));
    //       newState.searchedlistContacts = filteredSearchedContacts;
    //       newState.totalSearchedContacts -= ids.length;
    //       newState.listContacts = filteredContacts;
    //       newState.totalContacts -= ids.length;
    //     } else {
    //       const filteredContacts = newState.listContacts.filter((contact) => !ids.includes(contact.contactId));
    //       newState.listContacts = filteredContacts;
    //       newState.totalContacts -= ids.length;
    //     }
    //   }
    //   newState.deleteContact.loading = false;
    //   newState.deleteContact.success = true;
    //   newState.deleteContact.message = message as string;

    //   return newState;
    // }

    // // Add Contacts to list
    // case LIST_CONTACTS_ADD_TO_LIST.ADD: {
    //   const contactsToAdd = [...(payload.contacts as IContactItem[])];
    //   newState.searchedlistContacts = [...(payload.contacts as IContactItem[]), ...newState.searchedlistContacts];
    //   newState.totalSearchedContacts = payload.updatedCount as number;
    //   newState.listContacts = [...(payload.contacts as IContactItem[]), ...newState.listContacts];
    //   newState.totalContacts += contactsToAdd.length;
    //   return newState;
    // }

    // // Edit List Name
    // case LIST_CONTACTS_EDIT_LISTNAME.LOAD:
    //   newState.editListName.loading = true;
    //   return newState;

    // case LIST_CONTACTS_EDIT_LISTNAME.SUCCESS: {
    //   const { success, message, newListName } = action.payload;
    //   newState.editListName.loading = false;
    //   newState.editListName.success = success as boolean;
    //   newState.editListName.message = message as string;
    //   newState.listName = newListName as string;
    //   return newState;
    // }

    // case LIST_CONTACTS_EDIT_LISTNAME.FAIL: {
    //   const { message } = action.payload;
    //   newState.editListName.loading = false;
    //   newState.editListName.success = false;
    //   newState.editListName.message = message as string;
    //   return newState;
    // }

    // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    // case LIST_CONTACTS_ADD_NEW_CONTACT.LOAD:
    //   newState.addNewContact.loading = true;
    //   return newState;

    // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    // case LIST_CONTACTS_ADD_NEW_CONTACT.SUCCESS: {
    //   const { message, contact, isUpdate, updatedContactId } = action.payload;
    //   newState.addNewContact.loading = false;
    //   newState.addNewContact.success = true;
    //   newState.addNewContact.message = message as string;
    //   if (isUpdate) {
    //     const index = newState.listContacts.findIndex((contactItem: IContactItem) => contactItem?.contactId === updatedContactId);
    //     if (index !== -1 && contact) {
    //       newState.listContacts[index] = contact as IContactItem;
    //       return newState;
    //     }
    //   }
    //   if (contact) {
    //     newState.listContacts = [contact as IContactItem, ...newState.listContacts];
    //     newState.totalContacts += 1;
    //   }

    //   return newState;
    // }

    // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    // case LIST_CONTACTS_ADD_NEW_CONTACT.FAIL: {
    //   const { message } = action.payload;
    //   newState.addNewContact.loading = false;
    //   newState.addNewContact.success = false;
    //   newState.addNewContact.message = message as string;
    //   return newState;
    // }

    // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    // case LIST_CONTACTS_ADD_NEW_CONTACT.RESET: {
    //   newState.addNewContact.loading = false;
    //   newState.addNewContact.success = false;
    //   newState.addNewContact.message = '';
    //   return newState;
    // }

    // case LIST_CONTACTS_UPDATE_CONTACT.LOAD:
    //   newState.editContact.loading = true;
    //   return newState;

    // case LIST_CONTACTS_UPDATE_CONTACT.SUCCESS: {
    //   const { message, contact: payloadContact, updatedContactId } = action.payload;
    //   newState.editContact.loading = false;
    //   newState.editContact.success = true;
    //   newState.editContact.message = message as string;
    //   const updatedContactIndex = newState.listContacts.findIndex((contact) => contact.contactId === updatedContactId);
    //   if (updatedContactIndex !== -1) {
    //     const updatedContacts = [...newState.listContacts];
    //     updatedContacts[updatedContactIndex] = { ...newState.listContacts[updatedContactIndex], ...(payloadContact as IContactItem) };
    //     newState.listContacts = [...updatedContacts];
    //   }
    //   if (newState.searchTerm) {
    //     const updatedSearchedContactIndex = newState.searchedlistContacts.findIndex((contact) => contact.contactId === updatedContactId);
    //     if (updatedSearchedContactIndex !== -1) {
    //       newState.searchedlistContacts[updatedSearchedContactIndex] = payloadContact as IContactItem;
    //     }
    //   }
    //   return newState;
    // }

    // case LIST_CONTACTS_UPDATE_CONTACT.FAIL: {
    //   const { message } = action.payload;
    //   newState.editContact.loading = false;
    //   newState.editContact.success = false;
    //   newState.editContact.message = message as string;
    //   return newState;
    // }

    // case LIST_CONTACTS_UPDATE_CONTACT.RESET: {
    //   newState.editContact.loading = false;
    //   newState.editContact.success = false;
    //   newState.editContact.message = '';
    //   return newState;
    // }

    default:
      return newState;
  }
};
